import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import * as $ from 'jquery';
import { interval } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { Meta, MetaDefinition } from '@angular/platform-browser';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-duplicado-boleta',
  templateUrl: './duplicado-boleta.component.html',
  styleUrls: ['./duplicado-boleta.component.scss']
})
export class DuplicadoBoletaComponent implements OnInit {
  public isBrowser = isPlatformBrowser(this.platformId);
  public isServer = isPlatformServer(this.platformId);

  constructor(
    private titleService: Title,
    private metaService:Meta,
    @Inject(PLATFORM_ID) private platformId: any,
    private gtmService: GoogleTagManagerService,
  ) { }

  sub: any;

  ngOnInit(): void {
    this.titleService.setTitle('Duplicado de boleta | Metrogas');
    this.metaService.updateTag({ name: 'description', content: 'Para obtener duplicado de boleta puedes solicitarlo de forma digital en tu sucursal virtual, sin moverte de casa.' })

    if (this.isBrowser) {
      if (environment.production) {
        this.gtmService.addGtmToDom();
      }

      /*this.sub = interval(2000)
      .subscribe((val) => {
        $('.area-mi-cuenta').fadeIn(1000, function () {
          $('.area-mi-cuenta').fadeOut(1000, function () {
          });
        });
      });*/
    }
  }
}
